export default {
  基础版企业主页tag: 'Starter',
  标准版企业主页tag: 'Standard',
  升级版企业主页tag: 'Upgrade',
  旗舰版企业主页tag: 'Deluxe',
  尊享版企业主页tag: 'Vip',
}
